

import { useState } from "react";
import Config from "../../Config";

 

import Wall from "./Wall";
import WallSettings from "./WallSettings";

import Eat from "./Eat";

import Topic from "./Topic";
import PlanR from "./PlanR";
import CalendarYear from "./CalendarYear";
import Query from "./Query";
import DayHistory from "./DayHistory";
 




function NewsView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        //getData();
    }


    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";
    var tab5 = " m_item ";
    var tab6 = " m_item ";
    var tab7 = " m_item ";

    if(props.mainView.viewSelected == "wall") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "eat") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "topic") tab3 = tab3 + " selected";
    if(props.mainView.viewSelected == "plan") tab4 = tab4 + " selected";
    if(props.mainView.viewSelected == "calendar") tab5 = tab5 + " selected";
    if(props.mainView.viewSelected == "query") tab6 = tab6 + " selected";
    if(props.mainView.viewSelected == "day_history") tab7 = tab7 + " selected";

    var subMenu = <div className="submenu">
            <div className={tab1} module="news" view="wall" id="" onClick={props.mainView.quickGo} >Posty</div>
            <div className={tab2} module="news" view="eat" id="" onClick={props.mainView.quickGo} >Jadłospis</div>
            <div className={tab4}  module="news" view="plan" id="" onClick={props.mainView.quickGo} >Plan dnia</div>
            <div className={tab5}  module="news" view="calendar" id="" onClick={props.mainView.quickGo} >Kalendarz</div>
            <div className={tab7}  module="news" view="day_history" id="" onClick={props.mainView.quickGo} >Dziennik dnia</div>
        
            <div className={tab6}  module="news" view="query" id="" onClick={props.mainView.quickGo} >Ankiety i pytania</div>        
    </div>
 
 

    if(props.mainView.viewSelected == 'wall')
    {
        document.title ="Posty / Aktualności"; 

        return (
            <div className="econtent ">                           
           
                   {subMenu} 
                  <Wall  userData={props.userData}  mainView={props.mainView}  />
             </div>
        )
    }

    if(props.mainView.viewSelected == 'eat')
    {
        document.title ="Jadłospis / Aktualności"; 
        return (
            <div className="econtent ">    
                 {subMenu}  
                 <Eat  userData={props.userData}  mainView={props.mainView}  />
            </div>
        )
    }
 

    
    if(props.mainView.viewSelected == 'topic')
    {
        document.title ="Tematy zajęć / Aktualności"; 
        return (
            <div className="econtent ">    
                  {subMenu} 
                 <Topic  userData={props.userData}  mainView={props.mainView}  />
            </div>
        )
    }
    
    
    if(props.mainView.viewSelected == 'plan')
        {
            document.title ="Tematy zajęć / Aktualności"; 
            return (
                <div className="econtent ">    
                      {subMenu} 
                     <PlanR  userData={props.userData}  mainView={props.mainView}  />
                </div>
            )
        }



        if(props.mainView.viewSelected == 'calendar')
            {
                document.title ="Kalendarz"; 
                return (
                    <div className="econtent ">    
                          {subMenu} 
                          <CalendarYear  userData={props.userData}  mainView={props.mainView}  />
                    </div>
                )
            }

            




            if(props.mainView.viewSelected == 'query')
                {
                    document.title ="Ankiety i pytania"; 
                    return (
                        <div className="econtent ">    
                              {subMenu} 
                              <Query  userData={props.userData}  mainView={props.mainView}  />
                        </div>
                    )
                }
                


               if(props.mainView.viewSelected == 'day_history')
                {
                    document.title ="Dziennik dnia"; 
                    return (
                        <div className="econtent ">    
                              {subMenu} 
                              <DayHistory  userData={props.userData}  mainView={props.mainView}  />
                        </div>
                    )
                }     
                

    return (
        <div className="econtent ">
             {props.mainView.viewSelected}
        </div>
    );
}

export default NewsView ;